module.exports = __webpack_public_path__ + "static/hat-tip-5f72329d9b61ebc3ec62d4ebbd8d550b.png";